/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type IpWhitelistResponseDto = {
  id: number;
  tenantId: number;
  ipAddressRange: string;
  type: IpWhitelistResponseDto.type;
  updatedAt?: string;
  createdAt: string;
};
export namespace IpWhitelistResponseDto {
  export enum type {
    IPV4 = 'IPV4',
    IPV6 = 'IPV6',
  }
}

